import { axiosHandler } from "../utils/utils";
import { store } from "../redux/store";

export async function fetchPlayerData(spotracId) {
  if (!spotracId) return undefined;
  const json = await axiosHandler({
    url: `spotrac/player/${encodeURIComponent(spotracId)}`,
    state: store.getState()
  });
  return json.player;
}
